import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8011';

const ProjectCards = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/expenses/getAllExpenses`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch expenses');
        }

        const data = await response.json();
        const projectMap = data.reduce((acc, expense) => {
          if (!acc[expense.project]) {
            acc[expense.project] = 0;
          }
          acc[expense.project] += expense.price;
          return acc;
        }, {});

        const projects = Object.entries(projectMap).map(([project, total]) => ({
          project,
          total,
        }));
        setProjects(projects);
      } catch (error) {
        console.error('Error fetching expenses:', error);
      }
    };

    fetchExpenses();
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-semibold bg-themeColor2 p-3 rounded-lg text-themeColor1">Projects</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2 my-2">
        {projects.map((pro, index) => (
          <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-4">
              <h3 className="text-xl font-semibold text-themeColor1">{pro.project}</h3>
              <p className="text-themeColor2 font-semibold">Rs. {pro.total.toFixed(2)}</p>
            </div>
            <div className="bg-gray-100 p-4 text-center">
              <Link to={`/project/${encodeURIComponent(pro.project)}`} className="text-themeColor1 hover:underline hover:text-themeColor2">
                View More <i className="fa fa-arrow-circle-right"></i>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectCards;
